// extracted by mini-css-extract-plugin
export default {"dashboardWrapper":"dashboard_dashboardWrapper__UMSr7","mainContent":"dashboard_mainContent__IuqnL"};